/* ============================================================================
   tne-portal.js — Portal privado da revendedora (/pages/portal-catalogo)
   DistribuidorTopBioEuropa | Site institucional B2B

   Responsabilidades:
     1. Filtrar cards do catálogo por categoria via tabs (data-filtro / data-categoria)

   NOTA: o "Adicionar ao carrinho" é tratado pelo tne-cart-drawer.js (listener
   global em form[action*="/cart/add"]), que faz o AJAX add e abre o drawer.
   Não duplicar essa lógica aqui — antes este ficheiro também a fazia, o que
   adicionava o produto duas vezes.

   Sem dependências externas. Inicializa apenas se [data-tne-portal] estiver no DOM.
   ============================================================================ */
(function () {
  'use strict';

  function initTnePortal(root) {
    if (!root || root.dataset.tnePortalInit === '1') return;
    root.dataset.tnePortalInit = '1';

    initFiltros(root);
  }

  // --------------------------------------------------------------------------
  // 1. Filtros do catálogo
  // --------------------------------------------------------------------------
  function initFiltros(root) {
    var filtros = root.querySelectorAll('.tne-portal__filtros .tne-filtro');
    var grid = root.querySelector('[data-tne-portal-grid]');
    if (!filtros.length || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.tne-portal-card'));

    function applyFilter(filtro) {
      cards.forEach(function (card) {
        var categoria = card.getAttribute('data-categoria') || 'todos';
        // data-categoria pode ter múltiplos slugs separados por espaço
        // (ex: "beleza-pele emagrecimento saude-feminina"). Compatível com
        // o mesmo mecanismo de filtro de tne-produtos.js (home).
        var matches = filtro === 'todos'
          ? true
          : (' ' + categoria + ' ').indexOf(' ' + filtro + ' ') !== -1;

        if (matches) {
          card.classList.remove('is-hidden');
          card.classList.add('is-fading');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              card.classList.remove('is-fading');
            });
          });
        } else {
          card.classList.add('is-fading');
          window.setTimeout(function () {
            card.classList.add('is-hidden');
          }, 220);
        }
      });
    }

    filtros.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filtro = btn.getAttribute('data-filtro') || 'todos';
        filtros.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        applyFilter(filtro);
      });
    });
  }

  // --------------------------------------------------------------------------
  // Boot
  // --------------------------------------------------------------------------
  function boot() {
    document.querySelectorAll('[data-tne-portal]').forEach(initTnePortal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
